import { dom } from '@fortawesome/fontawesome-svg-core'
  ; (async () => {
    const { default: moment } = await import('moment')

    Promise.all([
      import(/* webpackMode: "eager" */ './deal-listing.scss'),
      import('../../plugins/semantic/popup'),
      import('../../plugins/semantic/table.css'),
      import('../../plugins/semantic/icon.css'),
      import('../../plugins/semantic/checkbox.css'),
      import('../../plugins/semantic/checkbox'),
      import('../../plugins/semantic/popup.css'),
      import('../../scripts/dbs/dbs.utilities.querystring'),
      import('../../plugins/semantic-calendar/calendar'),
      import('../../plugins/semantic-calendar/calendar.css'),
      import('../../plugins/semantic/form.scss'),
    ]).then(() => {
      $('.widget.deal-listing').each(function (i, el) {
        $(el).data('widget', new DealListing(el, moment))
        $(el).data('widget').init()
      })
    })
  })()

function DealListing(el, moment) {
  const self = this
  self.el = $(el)

  self.dealListingTemplate = require('./deal-listing.hbs')
  self.dealNoResultTemplate = require('./deal-listing-no-result.hbs')
  self.totalCount = 0
  self.offset = 0
  self.pageSize = 0

  self.qs = new dbs.utilities.querystring()

  self.tomorrow = new Date(new Date().setDate(new Date().getDate() + 1))
  self.today = new Date()
  self.maxDate = new moment().add(1, 'y').toDate()

  const SITE_HEADER_DESKTOP_HEIGHT = 86
  self.topOfDealsListing = $('.pt-article-listing').offset().top - SITE_HEADER_DESKTOP_HEIGHT
  self.headingStateNames = self.el.find('.js-heading-state-names')
  self.dealsTotalCount = {
    'NSW': 0,
    'QLD': 0,
    'SA': 0,
    'TAS': 0,
    'VIC': 0,
    'WA': 0,
    'NT': 0,
    'ACT': 0,
  };
  self.search = function (clear, disableHistory) {
    $('html, body').animate({ scrollTop: self.topOfDealsListing }, 500)

    self.el.find('.load-more-container').hide()

    const filters = {
      locationDisplayNames: null,
      location: null,
      type: null,
      from: null,
      to: null,
      parkBrand: null,
    }

    if (self.el.find('.filters .filter-set[data-category="location"] input:checked').length) {
      filters.location = []
      filters.locationDisplayNames = []
      self.el.find('.filters .filter-set[data-category="location"] input:checked').each(function (i, el) {
        filters.location.push($(el).val())
        filters.locationDisplayNames.push($(el).data('display-name'))
      })
    }

    if (self.el.find('.filters .filter-set[data-category="type"] input:checked').length) {
      filters.type = []
      self.el.find('.filters .filter-set[data-category="type"] input:checked').each(function (i, el) {
        filters.type.push($(el).val())
      })
    }

    if (self.el.find('.from-calendar input').val().length) {
      filters.from = moment(self.el.find('.from-calendar input').val(), 'DD/MM/YYYY').format('YYYY-MM-DD')
    }

    if (self.el.find('.to-calendar input').val().length) {
      filters.to = moment(self.el.find('.to-calendar input').val(), 'DD/MM/YYYY').format('YYYY-MM-DD')
    }

    if (!disableHistory) {
      let stateFilters = {}

      if (filters.location) {
        stateFilters.location = filters.location.join(',')
      }

      if (filters.type) {
        stateFilters.type = filters.type.join(',')
      }

      if (filters.from) {
        stateFilters.from = filters.from
      }

      if (filters.to) {
        stateFilters.to = filters.to
      }

      self.dealFiltersPushState(stateFilters)
    }

    // send filters to ajax
    $.ajax({
      url: $(el).attr('data-endpoint'),
      type: $(el).attr('data-method'),
      data: JSON.stringify(filters),
      dataType: 'json',
      contentType: 'application/json',
    })
      .done(function (data) {
        if (clear) {
          self.el.find('.results .articles, .results .message').remove()
        }
        console.log(data);


        if (data.Message === null && data.States != null) {
          const labels = document.querySelectorAll('.filter-set.category-state label');

          // Loop through all labels and update the text based on the checkbox value
          labels.forEach(label => {
            const stateValue = label.previousElementSibling.value;
            // Check if there's an existing count, if our count is zero, use the existing account
            let dealCount = 0;
            for (let i = 0; i < data.States.length; i++) {
              if (stateValue == data.States[i].State) {
                for (let x = 0; x < data.States[i].Groups.length; x++) {
                  dealCount = dealCount + data.States[i].Groups[x].Deals.length;
                }
                break;
              }
            }
            if(dealCount == 0 && self.dealsTotalCount[stateValue] > 0) {
              dealCount = self.dealsTotalCount[stateValue];
            }
            label.textContent = `${stateValue} (${dealCount})`;
          });
        } else {
          // Update counts with intitial retrieved counts
        const labels = document.querySelectorAll('.filter-set.category-state label');

          // Loop through all labels and update the text based on the checkbox value
          labels.forEach(label => {
            const stateValue = label.previousElementSibling.value;
            // Check if there's an existing count, if our count is zero, use the existing account
             var dealCount = 0;
             if(self.dealsTotalCount[stateValue] > 0) {
              dealCount = self.dealsTotalCount[stateValue];
            }
            label.textContent = `${stateValue} (${dealCount})`;
          })
        }


        let brand = $(el).attr('data-brand')
        if (brand === 'discoveryparks' && data.Message === null) {
          for (let i = 0; i < data.States.length; i++) {
            for (let x = 0; x < data.States[i].Groups.length; x++) {
              for (let y = 0; y < data.States[i].Groups[x].Deals.length; y++) {
                data.States[i].Groups[x].Deals[y].IsDiscoveryParks = 'true'
              }
            }
          }
        }

        const html = self.dealListingTemplate({
          data: data,
        })
        self.el.find('.results').html(html)

        if (data.Message && data.Message.length) {

          self.el.find('.results').html(self.dealNoResultTemplate())

        }

        // Update page title to include filter location display names
        let selectedStateNames = filters.locationDisplayNames
          ? ', ' + filters.locationDisplayNames.filter(Boolean).join(', ')
          : ''
        self.headingStateNames.text(selectedStateNames)
      })
      .fail(function () {
        // TODO decide what happens on fail
      })
      .always(function () {
        // See: https://fontawesome.com/v5/docs/apis/javascript/methods#dom-i2svg-params
        dom.i2svg()
      })
  }

  self.formatDate = function (date) {
    if (!date) return ''
    const day = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()
    return (
      (day.toString().length === 1 ? '0' + day : day) +
      '/' +
      (month.toString().length === 1 ? '0' + month : month) +
      '/' +
      year
    )
  }

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('DealListing init', self)
    }

    self.el.css('opacity', 1)
    self.termsModal = self.el.find('.terms-popup').modal()
    self.el.find('.ui.checkbox').checkbox()

    $('body').on('click', '.deals .deal .terms .expander', function (e) {
      e.preventDefault()
      self.termsModal.find('.content').html($(this).siblings('.fulltermcontent').html())
      self.termsModal.modal('show')
    })

    $('.terms-popup .close-btn').on('click', function (e) {
      e.preventDefault()
      $('.terms-popup').modal('hide')
    })

    $('body').on('click', '.deals .deal .terms .contracter', function (e) {
      e.preventDefault()
      $(this).slideUp()
      $(this).siblings('.content').slideUp()
      $(this).siblings('.expander').slideDown()
    })

    self.el.find('.from-calendar').calendar({
      type: 'date',
      minDate: self.today,
      maxDate: self.maxDate,
      endCalendar: $('.to-calendar'),
      popupOptions: {
        position: 'bottom left',
        lastResort: 'bottom left',
        prefer: 'opposite',
        hideOnScroll: false,
      },
      formatter: {
        // eslint-disable-next-line no-unused-vars
        date: function (date, settings) {
          return self.formatDate(date)
        },
      },
      parser: {
        // eslint-disable-next-line no-unused-vars
        date: function (text, settings) {
          return new moment(text, 'DD/MM/YYYY').toDate()
        },
      },
      // eslint-disable-next-line no-unused-vars
      onChange: function (date, text, mode) {
        if (!self.statePopped) {
          self.el.find('.from-mobile-calendar').calendar('set date', date, true, false)
          setTimeout(function () {
            self.search()
          }, 300)
        }
      },
    })
    self.el.find('.to-calendar').calendar({
      type: 'date',
      startCalendar: $('.from-calendar'),
      minDate: self.tomorrow,
      maxDate: self.maxDate,
      popupOptions: {
        position: 'bottom right',
        lastResort: 'bottom right',
        prefer: 'opposite',
        hideOnScroll: false,
      },
      formatter: {
        // eslint-disable-next-line no-unused-vars
        date: function (date, settings) {
          return self.formatDate(date)
        },
      },
      parser: {
        // eslint-disable-next-line no-unused-vars
        date: function (text, settings) {
          return new moment(text, 'DD/MM/YYYY').toDate()
        },
      },
      // eslint-disable-next-line no-unused-vars
      onChange: function (date, text, mode) {
        if (!self.statePopped) {
          self.el.find('.to-mobile-calendar').calendar('set date', date, true, false)
          setTimeout(function () {
            self.search()
          }, 300)
        }
      },
    })

    self.el.find('.from-mobile-calendar').calendar({
      type: 'date',
      minDate: self.today,
      maxDate: self.maxDate,
      endCalendar: $('.to-mobile-calendar'),
      popupOptions: {
        position: 'bottom left',
        lastResort: 'bottom left',
        prefer: 'opposite',
        hideOnScroll: false,
      },
      formatter: {
        // eslint-disable-next-line no-unused-vars
        date: function (date, settings) {
          return self.formatDate(date)
        },
      },
      parser: {
        // eslint-disable-next-line no-unused-vars
        date: function (text, settings) {
          return new moment(text, 'DD/MM/YYYY').toDate()
        },
      },
      // eslint-disable-next-line no-unused-vars
      onChange: function (date, text, mode) {
        if (!self.statePopped) {
          self.el.find('.from-calendar').calendar('set date', date, true, false)
          setTimeout(function () {
            self.search()
          }, 300)
        }
      },
    })
    self.el.find('.to-mobile-calendar').calendar({
      type: 'date',
      startCalendar: $('.from-mobile-calendar'),
      minDate: self.tomorrow,
      maxDate: self.maxDate,
      popupOptions: {
        position: 'bottom right',
        lastResort: 'bottom right',
        prefer: 'opposite',
        hideOnScroll: false,
      },
      formatter: {
        // eslint-disable-next-line no-unused-vars
        date: function (date, settings) {
          return self.formatDate(date)
        },
      },
      parser: {
        // eslint-disable-next-line no-unused-vars
        date: function (text, settings) {
          return new moment(text, 'DD/MM/YYYY').toDate()
        },
      },
      // eslint-disable-next-line no-unused-vars
      onChange: function (date, text, mode) {
        if (!self.statePopped) {
          self.el.find('.to-calendar').calendar('set date', date, true, false)
          setTimeout(function () {
            self.search()
          }, 300)
        }
      },
    })

    // SYNC
    self.el.find('.mobile-filters input[type="checkbox"]').on('change', function () {
      // if ($(this).parents('.mobile-state-filter').length){
      //   self.el.find('.mobile-filters .state-filter').html($(this).val());
      // }
      // if ($(this).parents('.mobile-type-filter').length){
      //   self.el.find('.mobile-filters .type-filter').html($(this).val());
      // }
      // $(this).parents('.ui.popup').find('input[type="checkbox"]:checked').not($(this)).prop('checked', false);
      // uncheck all main form checkboxes
      self.el.find('.filters input[type="checkbox"]').prop('checked', false)
      // sync with mobile checkboxes
      self.el.find('.mobile-filters input[type="checkbox"]').each(function (i, el) {
        if ($(el).is(':checked')) {
          let displayNameAttr = $(el).attr('data-display-name');
          console.log('.... ->');
          if (typeof displayNameAttr === 'undefined') {
            self.el.find('.filters input[value="' + $(el).attr('value') + '"]').prop('checked', true)
          } else {
            self.el.find('.filters input[data-display-name="' + displayNameAttr + '"]').prop('checked', true)
          }
        }
      })
      self.offset = 0
      self.search(true)
    })
    self.el.find('.filters input[type="checkbox"]').on('change', function () {
      // if ($(this).parents('.category-state.filter-set').length){
      //   self.el.find('.mobile-filters .state-filter').html($(this).val());
      // }
      // if ($(this).parents('.category-type.filter-set').length){
      //   self.el.find('.mobile-filters .type-filter').html($(this).val());
      // }
      // $(this).parents('.filter-set').find('input[type="checkbox"]:checked').not($(this)).prop('checked', false);
      // uncheck all mobile form checkboxes
      self.el.find('.mobile-filters input[type="checkbox"]').prop('checked', false)
      // sync with desktop checkboxes
      self.el.find('.filters input[type="checkbox"]').each(function (i, el) {
        if ($(el).is(':checked')) {
          console.log('is checked', $(el).val())
          self.el.find('.mobile-filters input[value="' + $(el).attr('value') + '"]').prop('checked', true)
        }
      })
      self.offset = 0
      self.search(true)
    })

    self.statePopped = false

    // handle popstate
    window.onpopstate = function (event) {
      self.statePopped = true

      // window.dbs.globalEvents.emit('search_popstate', event.state);
      self.setFiltersFromUrl()

      if (event.state) {
        self.search(true, true)
      }

      self.statePopped = false
    }

    self.loadMore = function () {
      self.offset = self.offset + self.pageSize
      self.search(false, true)
    }

    self.el.find('.mobile-filters .state-filter').popup({
      popup: self.el.find('.mobile-state-filter'),
      on: 'click',
      position: 'bottom right',
      lastResort: 'bottom right',
    })
    self.el.find('.mobile-filters .type-filter').popup({
      popup: self.el.find('.mobile-type-filter'),
      on: 'click',
      position: 'bottom right',
      lastResort: 'bottom right',
    })
    self.el.find('.mobile-filters .date-filter').popup({
      popup: self.el.find('.mobile-date-filter'),
      on: 'click',
      position: 'bottom right',
      lastResort: 'bottom right',
    })
    self.el.find('.clear-filters').click(function (event) {
      event.preventDefault()
      self.el.find('.filters input[type="checkbox"], .mobile-filters input[type="checkbox"]').prop('checked', false)
      self.el.find('.ui.calendar').calendar('clear')
      self.offset = 0
      self.search(true)
      self.el.find('.mobile-filters .state-filter').html('State')
      self.el.find('.mobile-filters .type-filter').html('Type')
    })

    self.setFiltersFromUrl()
    //
    self.retrieveDealCountsAndSearch(); // This calls search, after the count is retrieved to avoid race conditions
  }

  self.retrieveDealCountsAndSearch = function () {
    var localCount = {
      'NSW': 0,
      'QLD': 0,
      'SA': 0,
      'TAS': 0,
      'VIC': 0,
      'WA': 0,
      'NT': 0,
      'ACT': 0
    }
    $.ajax({
      url: $(el).attr('data-endpoint'),
      type: $(el).attr('data-method'),
      data: '{"locationDisplayNames":[],"location":[],"type":null,"from":null,"to":null,"parkBrand":null}',
      dataType: 'json',
      contentType: 'application/json',
    })
      .done(function (data) {
        if (data.Message === null && data.States != null) {
          const labels = document.querySelectorAll('.filter-set.category-state label');

          // Loop through all labels and update the text based on the checkbox value
          labels.forEach(label => {
            const stateValue = label.previousElementSibling.value;
            // Check if there's an existing count, if our count is zero, use the existing account
            let dealCount = 0;
            for (let i = 0; i < data.States.length; i++) {
              if (stateValue == data.States[i].State) {
                for (let x = 0; x < data.States[i].Groups.length; x++) {
                  dealCount = dealCount + data.States[i].Groups[x].Deals.length;
                }
                break;
              }
            }
            localCount[stateValue] = dealCount;
            self.dealsTotalCount[stateValue] = dealCount;
          });
        }

        self.search(true,true);
      });
  }

  self.dealFiltersPushState = function (filters) {
    // create a state object with all filters
    let url = window.location.pathname.replace(/\/+/g, '/')
    history.pushState({ filters: filters }, $(' head title').html(), url + '?' + $.param(filters))
  }

  self.setFiltersFromUrl = function () {
    self.statePopped = true
    self.location = self.qs.getParameter('location')
    self.type = self.qs.getParameter('type')
    self.from = self.qs.getParameter('from')
    self.to = self.qs.getParameter('to')

    // clear all filters
    self.el.find('.filters input[type="checkbox"]').prop('checked', false)
    self.el.find('.mobile-filters input[type="checkbox"]').prop('checked', false)
    self.el.find('.ui.calendar').calendar('clear')

    if (self.location) {
      const locationArray = self.location.split(',')
      for (let i = 0; i < locationArray.length; i++) {
        const locationArrayElement = locationArray[i]
        self.el.find('input[value="' + locationArrayElement + '"]').prop('checked', true)
        // self.el.find('.mobile-filters .state-filter').html(locationArrayElement);
      }
    }

    if (self.type) {
      const typeArray = self.type.split(',')
      for (let i = 0; i < typeArray.length; i++) {
        const typeArrayElement = typeArray[i]
        self.el.find('input[value="' + typeArrayElement + '"]').prop('checked', true)
        // self.el.find('.mobile-filters .type-filter').html(typeArrayElement);
      }
    }

    if (self.from) {
      self.el.find('.from-calendar').calendar('set date', moment(self.from, 'YYYY-MM-DD').toDate(), true, false)
    }

    if (self.to) {
      self.el.find('.to-calendar').calendar('set date', moment(self.to, 'YYYY-MM-DD').toDate(), true, false)
    }

    self.statePopped = false
  }

  setTimeout(function () {
    if ($('.deal-search-state').val()) {
      const dealState = $('.deal-search-state').val()
      self.el.find('.filters .category-state input[value="' + dealState + '"]').prop('checked', true)
      self.search()
    }
  }, 1000)
}
